import React from "react";
import {Formik} from "formik";
import {validator} from "@reside/forms";
import {SelectField, TextAreaField, TextField} from "@reside/ui";
import {SftpConfigFormFooter} from "./SftpConfigFormFooter";
import {HubAndSpokePage} from "./HubAndSpokePage";
import {
  FieldGrid,
  FormCardWrapper,
  FormSection,
  FormSectionTitle,
} from "../styles";
import {SftpConfig} from "../../../services/HubAndSpokeService";
import {SftpAuthMethods} from "../../../utils/constants";

const InitialValues = {
  name: "",
  notes: "",
  hostname: "",
  port: 0,
  username: "",
  auth_type: "",
  auth_value: "",
};

type Props = Readonly<{
  initialValues?: SftpConfig;
  onSubmit: (values: SftpConfig) => void;
}>;

export const SftpConfigForm = ({initialValues, onSubmit}: Props) => {
  const isEditMode = !!initialValues;
  const initialFormValues = isEditMode ? initialValues : InitialValues;

  const getValidationRules = () => {
    return {
      name: "required",
      hostname: "required",
      port: "required",
      username: "required",
      auth_type: "required",
      auth_value: "required",
    };
  };

  const validate = (values: SftpConfig) =>
    validator.validateAll(values, getValidationRules());

  return (
    // skipcq: JS-0415
    <Formik<SftpConfig>
      enableReinitialize
      initialValues={{...initialFormValues}}
      validate={validate}
      onSubmit={values => {
        onSubmit({
          ...values,
          hostname: values.hostname.toLowerCase(),
        });
      }}
    >
      {({values}) => (
        <HubAndSpokePage
          title={
            isEditMode ? "Edit SFTP Configuration" : "New SFTP Configuration"
          }
        >
          <FormCardWrapper>
            <FormSection>
              <FormSectionTitle>Details</FormSectionTitle>
              <FieldGrid>
                <TextField label="Name" name="name" />
                <TextField label="Notes" name="notes" />
              </FieldGrid>
            </FormSection>
            <FormSection>
              <FormSectionTitle>Connection</FormSectionTitle>
              <FieldGrid>
                <TextField
                  label="Hostname/IP Address"
                  name="hostname"
                  capitalize={false}
                />
                <TextField label="Port" name="port" type="number" />
                <TextField
                  label="Username"
                  name="username"
                  capitalize={false}
                />
              </FieldGrid>
            </FormSection>
            <FormSection>
              <FormSectionTitle>Authentication</FormSectionTitle>
              <FieldGrid>
                <SelectField
                  label="Authentication method"
                  name="auth_type"
                  options={[
                    {
                      value: SftpAuthMethods.password,
                      label: "Password",
                    },
                    {
                      value: SftpAuthMethods.privateKey,
                      label: "Private Key",
                    },
                  ]}
                />
                {values.auth_type === SftpAuthMethods.password && (
                  <TextField
                    label="Password"
                    name="auth_value"
                    capitalize={false}
                    type="password"
                  />
                )}
              </FieldGrid>
              {values.auth_type === SftpAuthMethods.privateKey && (
                <TextAreaField
                  label="Private Key"
                  name="auth_value"
                  type="text"
                />
              )}
            </FormSection>
            <SftpConfigFormFooter />
          </FormCardWrapper>
        </HubAndSpokePage>
      )}
    </Formik>
  );
};
